/*function handleVariantChange(variantId) {
    const currentVariant = currentProduct.variants.find(v => v.id === Number(variantId));
    if (!currentVariant) return;
  
    const packSize =Number(document.querySelector(`[data-vari-id="${currentVariant.id}"]`).getAttribute("data-pack-size"));

  
    // One-time pricing
    const oneTimePrice = currentVariant.price;
    const oneTimeCompare = currentVariant.compare_at_price || oneTimePrice;
    const onePerPiece = (oneTimePrice / packSize / 100).toFixed(2);
    const oneDisplay = (oneTimePrice / 100).toFixed(2);
    const oneCompareDisplay = (oneTimeCompare / 100).toFixed(2);
  
    // Find selected selling plan ID
    const planSelector = document.querySelector('.selling-plan-selector');
    const selectedPlanId = planSelector?.value ? Number(planSelector.value) : null;
  
    // Find correct selling plan allocation
    let matchedSellingPlan = null;
    if (selectedPlanId) {
      matchedSellingPlan = currentVariant.selling_plan_allocations.find(
        alloc => alloc.selling_plan_id === selectedPlanId
      );
    }
    // Fallback: use the first allocation
    if (!matchedSellingPlan) {
      matchedSellingPlan = currentVariant.selling_plan_allocations?.[0];
    }
  
    // Subscription pricing
    const subPrice = matchedSellingPlan?.price || oneTimePrice;
    const subCompare = matchedSellingPlan?.compare_at_price || oneTimePrice;
    const subPerPiece = (subPrice / packSize / 100).toFixed(2);
    const subDisplay = (subPrice / 100).toFixed(2);
    const subCompareDisplay = (subCompare / 100).toFixed(2);
  
    // Update One-Time Label
    const oneLabel = document.querySelector('.product__info-wrapper .onetime-radio .rc-radio__label');
    if (oneLabel) {
      oneLabel.innerHTML = `
        <span>One-Time Purchase</span>
        <span class="price-wrapper">
          <span>
            <span>$${oneDisplay}</span>
            <span class="st_price">$${oneCompareDisplay}</span>
          </span>
          <span class="per_bar">$${onePerPiece} per Piece</span>
        </span>
      `;
    }
  
    // Update Subscription Label
    const subLabel = document.querySelector('.product__info-wrapper .subscription-radio .rc-radio__label');
    if (subLabel) {
      subLabel.innerHTML = `
        <span>Subscribe & Save</span>
        <span class="price-wrapper">
          <span>
            <span>$${subDisplay}</span>
            <span class="st_price">$${subCompareDisplay}</span>
          </span>
          <span class="per_bar">$${subPerPiece} per Piece</span>
        </span>
      `;
    }
  }
  
  // Listen to variant change
  document.addEventListener('change', function (event) {
    if (
      event.target.classList.contains('product-variant-id') ||
      event.target.closest('.product-variant-id')
    ) {
      const input = event.target.classList.contains('product-variant-id')
        ? event.target
        : event.target.closest('.product-variant-id');
      handleVariantChange(input.value);
    }
  
    // If the user changes the delivery dropdown, re-run price logic
    if (event.target.classList.contains('selling-plan-selector')) {
      const variantId = document.querySelector('input[name="id"]')?.value;
      if (variantId) {
        handleVariantChange(variantId);
      }
    }
  });
  
  // Run once on page load
  document.addEventListener('DOMContentLoaded', function () {
    const initialVariantId = document.querySelector('input[name="id"]')?.value;
    if (initialVariantId) {
      handleVariantChange(initialVariantId);
    }
  });
  


*/

(() => {
  /* ───────────────────────────────── CONSTANTS ───────────────────────────────── */
  const WRAPPER_CLASS   = 'pack-subscription-wrapper';  // outer wrapper
  const BUY_GROUP_CLASS = 'product-buy-group';          // qty+button wrapper
  const TARGETS = [
    '.product-pack-selector__container',
    '.recharge-subscription-widget',
    '.product-form__quantity',
    '.product-buy-button',
  ];
  const root       = document.querySelector('.custom_product_wrapper');
  const mq         = window.matchMedia('(max-width: 500px)');
  if (!root) return;                                    // nothing to do

  /* ───────────────────────────────── HELPERS ───────────────────────────────── */
  function groupQtyAndButton(wrapper) {
    const qtyBlocks = wrapper.querySelectorAll('.product-form__quantity');
    if (!qtyBlocks.length) return;

    // Only run once per wrapper: if the first qty block already sits in a buy-group we’re done.
    if (qtyBlocks[0].parentElement.classList.contains(BUY_GROUP_CLASS)) return;

    qtyBlocks.forEach((qtyEl) => {
      // find the sibling buy button still inside the same outer wrapper
      const buyBtnEl = wrapper.querySelector('.product-buy-button');
      if (!buyBtnEl) return;

      const group = document.createElement('div');
      group.className = BUY_GROUP_CLASS;
      wrapper.insertBefore(group, qtyEl);   // place group before qty block
      group.appendChild(qtyEl);
      group.appendChild(buyBtnEl);          // move the button only once
    });
  }

  /* ──────────────────────────────── CORE ROUTINE ───────────────────────────── */
  let done = false;       // turns true when every target element is inside the wrapper
  let observing = true;   // simple flag so we can pause / resume the observer

  const observer = new MutationObserver(() => tryWrap());
  observer.observe(document.body, { childList: true, subtree: true });

  mq.addEventListener('change', tryWrap);   // in case you still need the breakpoint guard

  function tryWrap() {
    if (done /* job finished */ || (observing === false)) return;

    // If you really only want this on mobile, uncomment:
    // if (!mq.matches) return;

    /* Pause observation while we manipulate the DOM to avoid echo-loops */
    observing = false;
    observer.disconnect();

    /* 1. Ensure outer wrapper exists */
    let wrapper = root.querySelector('.' + WRAPPER_CLASS);
    if (!wrapper) {
      const first = root.querySelector(TARGETS.join(', '));
      if (!first) { resume(); return; }          // page not ready yet

      wrapper = document.createElement('div');
      wrapper.className = WRAPPER_CLASS;
      root.insertBefore(wrapper, first);         // ← your “run after this line” point
    }

    /* 2. Move each target block into the outer wrapper (preserves DOM order) */
    TARGETS.forEach((sel) => {
      const el = root.querySelector(sel);
      if (el && el.parentElement !== wrapper) wrapper.appendChild(el);
    });

    /* 3. Wrap qty + button together */
    groupQtyAndButton(wrapper);

    /* 4. Are all targets now inside? If yes, we’re finished for good */
    const everythingInside = TARGETS.every(
      (sel) => wrapper.querySelector(sel)
    );

    if (everythingInside) {
      done = true;

    } else {
      resume();                                 // keep listening for late-loaded widgets
    }
  }

  function resume() {
    observing = true;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Kick things off */
  tryWrap();
})();


window.addEventListener("DOMContentLoaded",()=>{

  appendShippingText();
})


function appendShippingText(){
  const root = document.querySelector('.custom_product_wrapper')
  const shippingText=document.querySelector(".shipping_text_custom");
  // --- relocate shipping text ------------------------
const targetBuyGroup = root.querySelector('.pack-subscription-wrapper');
console.log("shippingText",shippingText)
if (targetBuyGroup && shippingText) {
targetBuyGroup.appendChild(shippingText);
}


}